/**
 * Preview revision marker — commit SHA / Cloud Run revision for QA (Phase 3.2I).
 */

export type PreviewRevisionMarker = {
  gitSha: string
  shortSha: string
  buildId: string
  cloudRunRevision: string
  prTag: string
}

function readEnv(key: string): string {
  if (typeof process === 'undefined') return ''
  return (process.env[key] ?? '').trim()
}

export function getPreviewRevisionMarker(): PreviewRevisionMarker {
  const gitSha =
    readEnv('NEXT_PUBLIC_GIT_COMMIT_SHA') ||
    readEnv('COMMIT_SHA') ||
    'unknown'
  const buildId =
    readEnv('NEXT_PUBLIC_BUILD_TIMESTAMP') ||
    readEnv('BUILD_ID') ||
    ''
  const cloudRunRevision = readEnv('K_REVISION') || 'local'
  const prTag = readEnv('NEXT_PUBLIC_PREVIEW_PR_TAG') || ''
  return {
    gitSha,
    shortSha: gitSha === 'unknown' ? 'unknown' : gitSha.slice(0, 8),
    buildId,
    cloudRunRevision,
    prTag,
  }
}

/** Preview debug UI is on when Cloud Build passed NEXT_PUBLIC_PREVIEW_OUTCOME_DEBUG=true. */
export function isPreviewRevisionMarkerVisible(): boolean {
  const v = readEnv('NEXT_PUBLIC_PREVIEW_OUTCOME_DEBUG').toLowerCase()
  return v === 'true' || v === '1'
}
